<template>
  <b-row class="mb-1">
    <b-col>
      <b-row class="mt-1">
        <b-col>
          <divisoria-descricao
            :titulo="'Contrato Comercial'"
            :descricao="'Aqui você consegue visualizar e customizar o contrato comercial'"
          >
            <template slot="complemento-numero">
              <div class="circle">
                6
              </div>
            </template>
          </divisoria-descricao>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="8">
          <b-form-group
            label="Template do Contrato"
            style="padding-left: 0px;"
          >
            <v-select
              ref="templateContrato"
              v-model="propostaTemplate"
              :clearable="false"
              :disabled="true"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="4"
          align-self="center"
          style="margin-top: 0.8rem;"
        >
          <b-btn
            size="sm"
            :class="'ml-50 btn-primary btn-width'"
            variant="primary"
            @click="visualizarContrato"
          >
            <font-awesome-icon
              :icon="faEye"
            /> Visualizar
          </b-btn>
          <b-btn
            size="sm"
            class="btn ml-50 btn-width"
            variant="warning"
            @click="abreCustomizacao"
          >
            <font-awesome-icon
              :icon="faEdit"
            /> Customizar
          </b-btn>
        </b-col>
      </b-row>
      <b-modal
        id="modalCustomizacao"
        ref="modalCustomizacao"
        title="Customizar Contrato"
        size="xl"
        no-close-on-backdrop
      >
        <b-col class="text-right">
          <dropdown-tag

            ref="dropTagsContratante"
            :tags="tagsContratante"
            grupo-tags="Contratante"
            legenda="Tag Contratante"
            @enviar-pai="addTagTemplate"
          />
          <dropdown-tag
            ref="dropTagsSocio"
            :tags="tagsSocio"
            grupo-tags="Sócio"
            legenda="Tag Sócio"
            @enviar-pai="addTagTemplate"
          />
          <dropdown-tag
            ref="dropTagsProposta"
            :tags="tagsProposta"
            grupo-tags="Proposta"
            legenda="Tag Proposta"
            @enviar-pai="addTagTemplate"
          />
          <dropdown-tag
            ref="dropTagsAssinatura"
            :tags="tagsAssinatura"
            grupo-tags="Assinatura"
            legenda="Tag Assinatura"
            @enviar-pai="addTagTemplate"
          />
        </b-col>
        <quill-editor
          id="quillTemplate"
          ref="quillText"
          v-model="valueInner.contratoSubstituir"
          style="padding-bottom: 2%;"
          toolbar="#my-toolbar"
        />
        <b-modal
          ref="modalUsuarioDocusign"
          size="sm"
        >
          <legend class="col-form-label pt-0">
            Selecione o usuário</legend>
          <b-select
            v-model="selecionado"
            :options="usuariosFiltrado"
            text-field="nomeCompleto"
            value-field="id"
          />
          <template #modal-footer>
            <b-btn
              variant="primary"
              class="btn btn-sm"
              :disabled="!selecionado"
              @click="setUsuarioTag"
            >
              Confirmar
            </b-btn>
          </template>
        </b-modal>
        <template #modal-footer="{ cancel }">
          <b-button
            variant="primary"
            size="sm"
            class="mr-1"
            @click="salvar"
          >
            Salvar
          </b-button>
          <b-button
            variant="danger"
            size="sm"
            class="mr-1"
            @click="cancel()"
          >
            Cancelar
          </b-button>
        </template>
      </b-modal>
    </b-col>
  </b-row>
</template>

<style src="@core/scss/vue/libs/quill.scss" lang="scss"></style>
<style lang="scss">
#modalCustomizacao .modal-dialog{
  height: 94%;
}

#modalCustomizacao .modal-content{
  height: 95%;
}

#quillTemplate .ql-container {
  // height: 60vh;
  min-height: 53vh;
  max-height: 60vh;
}

#quillTemplate .ql-editor {
  overflow: auto;
  min-height: 100%;
  max-height: 53vh;

  &::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar {
    width: 10px;
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #bfbfbf;
  }
}

.btn-width {
  min-width: 20%;
}
</style>

<script>
import { quillEditor } from 'vue-quill-editor'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faQuestionCircle, faEye, faEdit, faPrint,
} from '@fortawesome/free-solid-svg-icons'
import vSelect from 'vue-select'
import api from '@/app-modulo/comercial/cadastro-proposta/shared/services/api'
import apiUsuarioInterno from '@/app-modulo/comuns/usuario-interno/shared/services/api'

export default {
  name: 'CertificadoDigitalEAnexo',
  components: {
    vSelect,
    quillEditor,
    FontAwesomeIcon,
    DivisoriaDescricao: () => import('@/shared/components/divisoria-descricao/DivisoriaDescricao.vue'),
    DropdownTag: () => import('@/shared/components/dropdown-tag/DropdownTag.vue'),
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    propostaValor: {
      type: Number,
      default: 0,
    },
    propostaTemplate: {
      type: String,
      default: '',
    },
    habilitarCampo: {
      type: Boolean,
      default: false,
    },
    propostaContrato: {
      type: String,
      default: '',
    },
    propostaId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      faQuestionCircle,
      faEye,
      faEdit,
      faPrint,
      selecionadoA3: false,
      selecionadoA1: false,
      visualizarCustomizacao: false,
      valueInner: {
        contratoSubstituir: '',
        certificadoSelecionado: false,
        contratualSelecionado: false,
        outrosSelecionado: false,
        certificado: [],
        senhaCertificado: null,
        tipoCertificado: null,
        dataVencimentoCertificado: null,
        certificadoFisico: null,
        nomeArquivoContratual: null,
        nomeArquivoOutrosAnexos: null,
        nomeArquivoCertificado: null,
        semCertificado: false,
        excluirContratual: false,
      },
      tagsContratante: ['Nome', 'CPF/CNPJ', 'Endereço', 'Nome Sócio Representante', 'CPF Sócio Representante'],
      tagsSocio: ['Nome', 'CPF/CNPJ', 'Endereço', 'Profissão', 'Função', 'Estado Civil', 'Nacionalidade', 'Data de nascimento', 'Início repetição', 'Final repetição'],
      tagsProposta: ['Serviços eventuais', 'Serviços recorrentes', 'Serviços avulsos', 'Valor contrato (R$)', 'Valor serviços não-recorrentes (R$)', 'Valor serviços recorrentes (R$)', 'Valor contrato (Extenso)', 'Data início vigência contrato', 'Data atual contrato', 'Checklist Perguntas e Respostas', 'Checklist Perguntas Respostas e Valor'],
      tagsAssinatura: ['Início assinatura sócio', 'Assinatura sócio', 'Final assinatura sócio', 'Assinatura Responsável', 'Assinatura Testemunha'],
      quill: {},
      contrato: null,
      usuarios: [],
      usuariosFiltrado: [],
      tagAtual: '',
      selecionado: null,
    }
  },
  watch: {
    value(value, oldValue) {
      if (value !== oldValue) {
        this.valueInner = value
      }
    },
    propostaContrato(value, oldValue) {
      if (value !== oldValue) {
        this.contrato = value
      }
    },
  },
  created() {
    this.valueInner = this.value
  },
  methods: {
    visualizarContrato() {
      if ((this.valueInner.id && this.valueInner.id > 0) || this.habilitarCampo) {
        this.valueInner.valorProposta = this.propostaValor
        localStorage.setItem('contrato', JSON.stringify(this.valueInner))
        const routeData = this.$router.resolve({ name: 'relatoriocontrato', params: { id: this.valueInner.id } })
        window.open(routeData.href, '_blank')
      }
    },
    salvar() {
      this.valueInner.contratoSubstituir = this.valueInner.contratoSubstituir.replace(/[\u200B-\u200D\uFEFF]/g, '')
      api.salvarAlteracaoContrato(this.valueInner, this.propostaId)
        .then(() => {
          this.$sucesso('Contrato salvo!')
          this.$emit('contrato-alterado', this.valueInner.contratoSubstituir)
          this.$refs.modalCustomizacao.hide()
        })
    },
    abreCustomizacao() {
      if ((this.valueInner.id && this.valueInner.id > 0) || this.habilitarCampo) {
        this.$refs.modalCustomizacao.show()
      }
    },
    addTagTemplate(value) {
      if (value.includes('{Assinatura Assinatura Responsável}') || value.includes('{Assinatura Assinatura Testemunha}')) {
        this.tagAtual = value
        if (!this.usuarios || this.usuarios.length === 0) {
          apiUsuarioInterno.getUsuariosMarcacaoDocuSign()
            .then(payload => {
              this.usuarios = payload.data
              this.usuariosFiltrado = value.includes('Responsável') ? this.usuarios.filter(fil => fil.docuSignResponsavel) : this.usuarios.filter(fil => fil.docuSignTestemunha)
              this.$refs.modalUsuarioDocusign.show()
            })
        } else {
          this.usuariosFiltrado = value.includes('Responsável') ? this.usuarios.filter(fil => fil.docuSignResponsavel) : this.usuarios.filter(fil => fil.docuSignTestemunha)
          this.$refs.modalUsuarioDocusign.show()
        }
      } else {
        this.quill = this.$refs.quillText.quill
        this.quill.insertText(this.quill.getSelection(true), value, 'bold', true)
        this.quill.setSelection(this.quill.getSelection(true).index)
        this.quill.insertText(this.quill.getSelection(true), ' ', 'bold', false)
      }
    },
    setUsuarioTag() {
      const usuario = this.usuarios.find(find => find.id === this.selecionado)
      this.quill = this.$refs.quillText.quill
      const tag = this.tagAtual.replace('}', ` ${usuario.id} - ${usuario.nomeCompleto}}`)
      this.quill.insertText(this.quill.getSelection(true), tag, 'bold', true)
      this.quill.setSelection(this.quill.getSelection(true).index)
      this.quill.insertText(this.quill.getSelection(true), ' ', 'bold', false)
      this.selecionado = null
      this.$refs.modalUsuarioDocusign.hide()
    },
  },
}
</script>
